module.exports = __webpack_public_path__ + "static/img/6-1.13a0272.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/6-1.png
// module id = 0+hY
// module chunks = 25